import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import warningIcon from 'assets/icons/warning.svg'

interface AttractionAlertProps {
    alert: string
}

const AttractionAlert = ({ alert }: AttractionAlertProps) => (
    <Box direction="row" justify="center" gap={[8, 4]}>
        <img src={warningIcon} alt="" />
        <Text color="error" variant="bodySmallStrong">
            {alert}
        </Text>
    </Box>
)

export default AttractionAlert
